import styled from '../../../../../style/styled';

export const AddIconContainer = styled.div`
  cursor: pointer;
`;
